import axios from 'axios';

export const loadAxiosPlugin = () => {
  axios.interceptors.request.use(
    (config) => {
      // HERE'S HOW TO DO THIS WITH RTK QUERY:
      // https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#automatic-re-authorization-by-extending-fetchbasequery
      // add token to headers before sending request
      const token = localStorage.getItem('token');
      if (token !== null && config.headers) {
        config.headers.Authorization = `Token ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
};
